import { ApiModels as M } from "@entitlements/api-models"
import { ActiveSubscription } from "../types"

/**
 * Convert a subscription fetched from the API into a renderable active subscription
 * @param subscription the API subscription model
 * @param unitType the unit type associated with this subscription type (e.g., tokens, LuxPlay devices, etc)
 * @returns the converted subscription object
 */
export function convertSubscription(subscription: M["Subscription"]): ActiveSubscription {
	return {
		id: subscription.id,
		availableUnits: subscription.available_units,
		editUrls: subscription.edit_urls,
		name: subscription.name,
		nextBillingTime: new Date(subscription.next_bill_date * 1000),
		nextRefreshTime: subscription.next_refresh_date
			? new Date(subscription.next_refresh_date * 1000)
			: null,
		status: subscription.status,
		totalUnits: subscription.total_units,
		type: subscription.type,
	}
}
